__turbopack_context__.v({
  "ActiveCompany": "_9RSnXa_ActiveCompany",
  "Address": "_9RSnXa_Address",
  "AddressIcon": "_9RSnXa_AddressIcon",
  "AddressIconWrapper": "_9RSnXa_AddressIconWrapper",
  "AddressLabel": "_9RSnXa_AddressLabel",
  "BookmarkDesktop": "_9RSnXa_BookmarkDesktop",
  "BookmarkMobile": "_9RSnXa_BookmarkMobile",
  "BoxText": "_9RSnXa_BoxText",
  "BoxTitle": "_9RSnXa_BoxTitle",
  "ButtonMain": "_9RSnXa_ButtonMain",
  "Buttons": "_9RSnXa_Buttons",
  "CheckboxIcon": "_9RSnXa_CheckboxIcon",
  "CheckboxIconWrapper": "_9RSnXa_CheckboxIconWrapper",
  "CheckboxItem": "_9RSnXa_CheckboxItem",
  "CheckboxLabel": "_9RSnXa_CheckboxLabel",
  "CheckboxListScroll": "_9RSnXa_CheckboxListScroll",
  "ClearAllFilters": "_9RSnXa_ClearAllFilters",
  "Container": "_9RSnXa_Container",
  "Content": "_9RSnXa_Content",
  "CountrySelectorArrowIcon": "_9RSnXa_CountrySelectorArrowIcon",
  "CountrySelectorButton": "_9RSnXa_CountrySelectorButton",
  "CountrySelectorIcon": "_9RSnXa_CountrySelectorIcon",
  "CountrySelectorText": "_9RSnXa_CountrySelectorText",
  "Disabled": "_9RSnXa_Disabled",
  "DropdownClear": "_9RSnXa_DropdownClear",
  "DropdownClearIcon": "_9RSnXa_DropdownClearIcon",
  "DropdownContent": "_9RSnXa_DropdownContent",
  "DropdownSearch": "_9RSnXa_DropdownSearch",
  "DropdownSearchIcon": "_9RSnXa_DropdownSearchIcon",
  "DropdownSearchWrapper": "_9RSnXa_DropdownSearchWrapper",
  "EmptyState": "_9RSnXa_EmptyState",
  "Filter": "_9RSnXa_Filter",
  "FilterButton": "_9RSnXa_FilterButton",
  "FilterButtonWrapper": "_9RSnXa_FilterButtonWrapper",
  "FilterButtons": "_9RSnXa_FilterButtons",
  "FilterIcon": "_9RSnXa_FilterIcon",
  "FilterSeparator": "_9RSnXa_FilterSeparator",
  "FlexWrapContainer": "_9RSnXa_FlexWrapContainer",
  "GridWrapper": "_9RSnXa_GridWrapper",
  "HasNetwork": "_9RSnXa_HasNetwork",
  "Header": "_9RSnXa_Header",
  "IndividualTabContainer": "_9RSnXa_IndividualTabContainer",
  "IndividualTabHeader": "_9RSnXa_IndividualTabHeader",
  "IndividualTabHeaderWrapper": "_9RSnXa_IndividualTabHeaderWrapper",
  "IndividualTabSector": "_9RSnXa_IndividualTabSector",
  "IndividualTabSectors": "_9RSnXa_IndividualTabSectors",
  "IndividualTabSectorsList": "_9RSnXa_IndividualTabSectorsList",
  "IndividualTabTitle": "_9RSnXa_IndividualTabTitle",
  "IndividualTabWrapper": "_9RSnXa_IndividualTabWrapper",
  "LayoutWrapper": "_9RSnXa_LayoutWrapper",
  "Left": "_9RSnXa_Left",
  "ListWrapper": "_9RSnXa_ListWrapper",
  "Main": "_9RSnXa_Main",
  "NetworkTabWrapper": "_9RSnXa_NetworkTabWrapper",
  "Open": "_9RSnXa_Open",
  "Overflow": "_9RSnXa_Overflow",
  "RelatedIndividuals": "_9RSnXa_RelatedIndividuals",
  "RelatedIndividualsTitle": "_9RSnXa_RelatedIndividualsTitle",
  "Right": "_9RSnXa_Right",
  "RightFooter": "_9RSnXa_RightFooter",
  "RoleCard": "_9RSnXa_RoleCard",
  "RoleDescription": "_9RSnXa_RoleDescription",
  "RoleTitle": "_9RSnXa_RoleTitle",
  "RoleTitleWrapper": "_9RSnXa_RoleTitleWrapper",
  "RolesWrapper": "_9RSnXa_RolesWrapper",
  "Root": "_9RSnXa_Root",
  "Search": "_9RSnXa_Search",
  "SearchIcon": "_9RSnXa_SearchIcon",
  "SearchInput": "_9RSnXa_SearchInput",
  "SearchInputContainer": "_9RSnXa_SearchInputContainer",
  "SkeletonLoader": "_9RSnXa_SkeletonLoader",
  "TabArea": "_9RSnXa_TabArea",
  "TabAreaLeft": "_9RSnXa_TabAreaLeft",
  "TabAreaRight": "_9RSnXa_TabAreaRight",
  "TabContent": "_9RSnXa_TabContent",
  "TabContentItem": "_9RSnXa_TabContentItem",
  "TabContentItemLabel": "_9RSnXa_TabContentItemLabel",
  "TabContentItemRole": "_9RSnXa_TabContentItemRole",
  "TabContentItemTitle": "_9RSnXa_TabContentItemTitle",
  "ThreeColumns": "_9RSnXa_ThreeColumns",
  "Title": "_9RSnXa_Title",
  "TopSection--WithButton": "_9RSnXa_TopSection--WithButton",
  "TopSectionHeader": "_9RSnXa_TopSectionHeader",
  "TwoColumns": "_9RSnXa_TwoColumns",
  "ZeroStateWrapper": "_9RSnXa_ZeroStateWrapper",
  "skeleton-loading": "_9RSnXa_skeleton-loading",
});
